import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import MyButton from '../../../utils/MyButton'
import { FaArrowCircleLeft } from 'react-icons/fa'
import IndicadoresPrestador from './IndicadoresPrestador'
import './IndicadoresPerfil.css'

export class IndicadoresPerfil extends Component {
  render() {
    return (
        <div>
        <div className="titulo_section">
        <div className="titulo_clientes">
        <h1 className="text-clientes">Indicadores del Prestador</h1>
        <hr className="clientes_separator"></hr>            
        
        </div>

        <div className="div_boton">
        <Link to={`/dashboard/perfilcliente/${this.props.match.params.clienteId}`}>
        <MyButton tip="Volver">
         <FaArrowCircleLeft color="#03178C" className="icon-eliminarcliente"/>
        </MyButton>
        </Link>
        </div>
        </div>
        
        <div className='container-indicadoresperfil'>
        <IndicadoresPrestador clienteId={this.props.match.params.clienteId} />
        </div>
        </div>

    )
  }
}

export default IndicadoresPerfil